<template>
  <div class="animated fadeIn">
    <b-alert v-if="!ECFOP" variant="warning" show>
      Funzione disponibile solo per ECFOP.
    </b-alert>
    <b-alert v-else-if="!corsistaid" variant="warning" show>
      Funzione riservata ai corsisti.
    </b-alert>
    <b-alert v-else-if="!prima" variant="warning" show>
      Funzione riservata ai corsisti di prima annualità.
    </b-alert>
    <b-row v-else>
      <b-col md="6" class="mb-4">
        <b-card title="Foto attuale" class="h-100">
          <div class="selfie-current">
            <img
              :src="getFoto(corsistaid)"
              alt="Foto attuale"
              :onerror="'this.onerror=null; this.src=\'' + getFakeFoto(sesso) + '\';'"
            />
          </div>

          <div v-if="fotoStato == 'checking'" class="mt-3 text-center text-muted">
            <i class="fa fa-spinner fa-spin"></i>&nbsp; Verifica dello stato della foto…
          </div>

          <b-alert v-else-if="fotoStato == 'locked'" variant="warning" show class="mt-3">
            La foto attuale è stata inserita/aggiornata il <b>{{ fotoData }}</b>: per quest'anno scolastico
            <b>non è più possibile modificarla</b>.
          </b-alert>

          <b-alert v-else-if="fotoStato == 'updatable'" variant="info" show class="mt-3">
            La foto potrà essere <b>inserita o aggiornata una sola volta</b>: assicurati che sia un selfie conforme.
          </b-alert>

          <b-alert v-else-if="fotoStato == 'error'" variant="danger" show class="mt-3">
            {{ fotoMsg }}
            <b-button size="sm" variant="outline-danger" class="ml-2" @click="verificaDataFoto">Riprova</b-button>
          </b-alert>

          <b-button
            v-if="fase == 'idle' && fotoStato == 'updatable'"
            variant="primary"
            block
            class="mt-3"
            @click="startCamera"
          >
            <i class="fa fa-camera"></i>&nbsp; Scatta una foto
          </b-button>
        </b-card>
      </b-col>
      <b-col md="6" class="mb-4">
        <b-card title="Nuova foto" class="h-100">
          <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>

          <div v-if="fase == 'camera'" class="selfie-stage">
            <video ref="video" autoplay playsinline muted></video>
            <div class="selfie-overlay">
              <div class="selfie-guide"></div>
            </div>
          </div>

          <div v-else-if="fase == 'shot'" class="selfie-stage">
            <img :src="captured" alt="Scatto" />
          </div>

          <div v-else-if="fotoStato == 'locked'" class="text-center text-muted py-5">
            <i class="fa fa-lock fa-4x"></i>
            <p class="mt-3 mb-0">La foto non è aggiornabile per quest'anno scolastico.</p>
          </div>

          <div v-else class="text-center text-muted py-5">
            <i class="fa fa-user-circle-o fa-4x"></i>
            <p class="mt-3 mb-0">Premi "Scatta una foto" per iniziare.</p>
          </div>

          <div v-if="fase == 'camera'" class="mt-3 d-flex justify-content-center">
            <b-button variant="primary" @click="capture">
              <i class="fa fa-camera"></i>&nbsp; Scatta
            </b-button>
            <b-button variant="secondary" class="ml-2" @click="cancel">
              Annulla
            </b-button>
          </div>

          <div v-if="fase == 'shot'" class="mt-3 d-flex justify-content-center">
            <b-button variant="warning" @click="retake">
              <i class="fa fa-refresh"></i>&nbsp; Rifai
            </b-button>
            <b-button variant="success" class="ml-2" @click="send" :disabled="verificaStato !== 'ok' || invioStato == 'sending'">
              <i class="fa fa-send"></i>&nbsp; <span v-if="invioStato == 'sending'">Invio in corso…</span><span v-else>Invia</span>
            </b-button>
            <b-button variant="secondary" class="ml-2" @click="cancel">
              Annulla
            </b-button>
          </div>

          <div v-if="fase == 'shot' && verificaStato == 'loading'" class="mt-3 text-center text-muted">
            <i class="fa fa-spinner fa-spin"></i>&nbsp; Verifica della foto…
          </div>

          <b-alert v-else-if="fase == 'shot' && verificaStato == 'ok'" variant="success" show class="mt-3">
            <i class="fa fa-check-circle"></i>&nbsp; Foto conforme: puoi inviarla.
          </b-alert>

          <b-alert v-else-if="fase == 'shot' && verificaStato == 'fail'" variant="warning" show class="mt-3">
            <div class="mb-1">
              <i class="fa fa-exclamation-triangle"></i>&nbsp; La foto non sembra un selfie fototessera:
            </div>
            <ul class="mb-0 pl-3">
              <li v-for="c in verificaChecks" :key="c.id" :class="c.ok ? 'text-success' : 'text-danger'">
                {{ c.ok ? '✓' : '✗' }} {{ c.label }}
                <small v-if="c.value" class="text-muted">({{ c.value }})</small>
              </li>
            </ul>
          </b-alert>

          <b-alert v-else-if="fase == 'shot' && verificaStato == 'unavailable'" variant="info" show class="mt-3">
            {{ verificaMsg }}
          </b-alert>

          <b-alert v-if="infoMsg" variant="info" show class="mt-3">{{ infoMsg }}</b-alert>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { verifySelfie } from "@/shared/vision";

export default {
  name: 'Selfie',
  mixins: [window.myMixin],
  data: function () {
    return {
      fase: 'idle', // 'idle' | 'camera' | 'shot'
      captured: null,
      error: '',
      infoMsg: '',
      corsistaid: 0,
      sesso: '',
      stream: null,
      verificaStato: 'idle', // 'idle' | 'loading' | 'ok' | 'fail' | 'unavailable'
      verificaChecks: [],
      verificaMsg: '',
      invioStato: 'idle', // 'idle' | 'sending' | 'sent' | 'error'
      fotoRefresh: 0, // cache-buster per ricaricare la "Foto attuale" dopo l'invio
      fotoStato: 'checking', // 'checking' | 'updatable' | 'locked' | 'error'
      fotoData: null, // data foto attuale ("Y-m-d H:i:s") o null
      fotoCutoff: null, // "Y-m-d" da Settembre dell'anno base scelto al login
      fotoMsg: ''
    }
  },
  mounted: function () {
    this.corsistaid = this.getCorsID()
    var td = this.getTokenData()
    if (td && td.sub && td.sub.guest)
      this.sesso = td.sub.guest.sesso || ''
    if (this.corsistaid && this.prima)
      this.verificaDataFoto()
  },
  computed: {
    prima: function () {
      // corsista di prima annualità (annualita == 1, nel token del guest)
      var td = this.getTokenData()
      return !!(td && td.sub && td.sub.guest && td.sub.guest.annualita == 1)
    }
  },
  beforeDestroy: function () {
    this.stopStream()
  },
  methods: {
    MD5(c) {
      // replico esattamente il pattern di Registro.vue (MD5 salato)
      return window.MD5(c + "3cf0ps3cr3t")
    },
    getFoto(corsistaid) {
      let file = `foto/${corsistaid}/foto.png`
      return `https://swone.ecfop.it/corsista/${file}/chk/${this.MD5(file)}?v=${this.fotoRefresh}`
    },
    getFakeFoto(sesso) {
      let file = `foto/${sesso}icon.png`
      return `https://swone.ecfop.it/corsista/${file}/chk/${this.MD5(file)}`
    },
    async startCamera() {
      this.error = ''
      this.infoMsg = ''
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.error = "Accesso alla fotocamera non disponibile: serve una connessione sicura (HTTPS) o localhost."
        return
      }
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: 'user',
            width: { ideal: 1280 },
            height: { ideal: 960 }
          },
          audio: false
        })
        this.fase = 'camera'
        this.$nextTick(() => {
          var video = this.$refs.video
          if (video) {
            video.srcObject = this.stream
            video.play().catch(() => {})
          }
        })
      } catch (e) {
        console.log("SELFIE ERR:", e)
        if (e.name === 'NotAllowedError' || e.name === 'PermissionDeniedError')
          this.error = "Permesso negato: abilita l'accesso alla fotocamera dalle impostazioni del browser."
        else if (e.name === 'NotFoundError' || e.name === 'DevicesNotFoundError')
          this.error = "Nessuna fotocamera trovata sul dispositivo."
        else
          this.error = "Impossibile accedere alla fotocamera: " + (e.message || e.name)
      }
    },
    stopStream() {
      if (this.stream) {
        this.stream.getTracks().forEach(t => t.stop())
        this.stream = null
      }
    },
    capture() {
      var video = this.$refs.video
      if (!video || !video.videoWidth) {
        this.error = "La fotocamera non è ancora pronta: riprova tra un attimo."
        return
      }
      const vw = video.videoWidth
      const vh = video.videoHeight
      const W = 600
      const H = 800 // rapporto verticale 3:4 tipo fototessera
      const tAspect = W / H
      const vAspect = vw / vh
      let srcW, srcH, srcX, srcY
      if (vAspect > tAspect) {
        // video più largo del target: ritaglio laterale
        srcH = vh
        srcW = vh * tAspect
        srcX = (vw - srcW) / 2
        srcY = 0
      } else {
        // video più alto del target: ritaglio in alto/basso
        srcW = vw
        srcH = vw / tAspect
        srcX = 0
        srcY = (vh - srcH) / 2
      }
      var canvas = document.createElement('canvas')
      canvas.width = W
      canvas.height = H
      canvas.getContext('2d').drawImage(video, srcX, srcY, srcW, srcH, 0, 0, W, H)
      this.captured = canvas.toDataURL('image/png')
      this.stopStream()
      this.fase = 'shot'
      this.error = ''
      this.verificaFoto()
    },
    async verificaDataFoto() {
      this.fotoStato = 'checking'
      this.fotoMsg = ''
      try {
        // cutoff: Settembre dell'anno base scelto al login (es. anno 2026 → 2026-09-01)
        var td = this.getTokenData()
        this.fotoCutoff = (td && td.sub && td.sub.anno) ? (td.sub.anno + '-09-01') : null
        var resp = await this.$http.get(window.baseurl + '/corsFotoDate')
        var data = resp.data || {}
        if (!data.ok)
          throw new Error(data.message || 'errore')
        this.fotoData = data.data || null
        if (this.fotoData && this.fotoCutoff && this.fotoData.slice(0, 10) >= this.fotoCutoff)
          this.fotoStato = 'locked'
        else
          this.fotoStato = 'updatable'
        console.log("SELFIE DATA FOTO:", this.fotoData, "cutoff", this.fotoCutoff, "→", this.fotoStato)
      } catch (e) {
        console.log("SELFIE DATA FOTO ERR:", e)
        this.fotoStato = 'error'
        this.fotoMsg = "Impossibile verificare lo stato della foto attuale: riprova."
      }
    },
    async verificaFoto() {
      this.verificaStato = 'loading'
      this.verificaChecks = []
      this.verificaMsg = ''
      try {
        var img = new Image()
        img.src = this.captured
        await new Promise((resolve, reject) => {
          img.onload = resolve
          img.onerror = reject
        })
        var res = await verifySelfie(img)
        this.verificaChecks = res.checks
        this.verificaStato = res.ok ? 'ok' : 'fail'
        console.log("SELFIE VERIFICA:", res)
      } catch (e) {
        console.log("SELFIE VERIFICA ERR:", e)
        this.verificaStato = 'unavailable'
        this.verificaMsg = "Verifica automatica non disponibile su questo dispositivo: la foto potrà comunque essere inviata."
      }
    },
    retake() {
      this.captured = null
      this.infoMsg = ''
      this.error = ''
      this.verificaStato = 'idle'
      this.verificaChecks = []
      this.invioStato = 'idle'
      this.startCamera()
    },
    cancel() {
      this.stopStream()
      this.captured = null
      this.infoMsg = ''
      this.error = ''
      this.verificaStato = 'idle'
      this.verificaChecks = []
      this.invioStato = 'idle'
      this.fase = 'idle'
    },
    async send() {
      this.invioStato = 'sending'
      this.infoMsg = ''
      try {
        // invio al server: endpoint SWONE2 che replica swone/uploadCorsFoto.php
        var resp = await this.$http.post(window.baseurl + '/uploadFotoCorsista', { image: this.captured })
        var data = resp.data || {}
        if (data.ok) {
          this.invioStato = 'sent'
          this.fotoRefresh++
          this.infoMsg = "Foto inviata con successo."
          // torna alla vista iniziale: la "Foto attuale" mostrerà la nuova foto
          this.fase = 'idle'
          this.captured = null
          this.verificaStato = 'idle'
          this.verificaChecks = []
          // la foto ora è recente: lo stato diventa "locked" (una sola modifica)
          this.verificaDataFoto()
        } else {
          this.invioStato = 'error'
          this.infoMsg = "Invio non riuscito: " + (data.message || "errore sconosciuto")
        }
      } catch (e) {
        console.log("SELFIE SEND ERR:", e)
        this.invioStato = 'error'
        this.infoMsg = "Errore durante l'invio: " + (((e.response || {}).data || {}).message || e.message || "errore sconosciuto")
      }
    }
  }
}
</script>

<style scoped>
.selfie-current {
  text-align: center;
}
.selfie-current img {
  max-height: 320px;
  border-radius: 6px;
  border: 1px solid #ddd;
}
.selfie-stage {
  position: relative;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  aspect-ratio: 3 / 4;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}
.selfie-stage video,
.selfie-stage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.selfie-stage video {
  transform: scaleX(-1);
}
.selfie-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.selfie-guide {
  width: 70%;
  height: 92%;
  border: 2px dashed rgba(255, 255, 255, 0.85);
  border-radius: 12px;
}
</style>

